import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    fetchSpecialityDetails, fetchDoctorsBySpeciality, fetchAllBlogs, fetchSpecialityFAQ,
    fetchSpecialityVideos, fetchSpecialtyDetailsBanner
} from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import leftArrow from "../assets/images/doc-detail/leftwrrw.svg";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { NavLink } from 'react-router-dom';
import SpecialBan from "../assets/images/internal-medicine-ban.jpeg";
import grid1Img from "../assets/images/speci-detail/grid1.jpg";
import grid2Img from "../assets/images/speci-detail/grid2.jpg";
import grid3Img from "../assets/images/speci-detail/grid3.jpg";
import grid4Img from "../assets/images/speci-detail/grid4.jpg";
import videoImg from "../assets/images/speci-detail/videoimg.jpg";
import blkArrow from "../assets/images/spciallites/blkarw.svg";
import videoPlaybtn from "../assets/images/speci-detail/vdoplybtn.png";
import Doct1 from '../assets/images/doct1.png';
import Doct2 from '../assets/images/doct2.png';
import Doct3 from '../assets/images/doct3.png';
import Doct4 from '../assets/images/doct4.png';
import VectorIcon from '../assets/images/Vector.png';

const InternalMedicine = () => {
    const { id } = useParams();
    const [bannerData, setBannerData] = useState([]);
    const [speciality, setSpeciality] = useState(null);
    const [doctors, setDoctors] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [faq, setFaq] = useState([]);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [videos, setVideos] = useState([]);
    const [loadingVideos, setLoadingVideos] = useState(true);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const response = await fetchSpecialityDetails(id);
                if (response && response.data) {
                    setSpeciality(response.data);
                }

                // Specialty Banner
                const bannerResponse = await fetchSpecialtyDetailsBanner();
                if (bannerResponse && bannerResponse.data) {
                    setBannerData(bannerResponse.data);
                }

                // Fetch doctors by speciality
                const doctorsResponse = await fetchDoctorsBySpeciality(id);
                if (doctorsResponse && doctorsResponse.data) {
                    setDoctors(doctorsResponse.data);
                }

                // Fetch FAQ data
                const faqResponse = await fetchSpecialityFAQ(id);  // Assuming the FAQ is related to the speciality ID
                if (faqResponse && faqResponse.data) {
                    console.log("FAQ List ----", faqResponse);
                    setFaq(faqResponse.data);
                }

                // Fetch All Blogs
                const blogsResponse = await fetchAllBlogs();
                if (blogsResponse && blogsResponse.data) {
                    setBlogs(blogsResponse.data);
                }

            } catch (error) {
                console.error("Error fetching speciality details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [id]);

    const handleOpenVideo = (url) => {
        setVideoUrl(url);
        setShowVideoModal(true);
    };
    const handleCloseVideo = () => {
        setShowVideoModal(false);
        setVideoUrl(null);

        // Manually remove Bootstrap modal-related classes
        document.body.classList.remove("modal-open");
        // Remove the modal backdrop if it exists
        const modalBackdrops = document.getElementsByClassName("modal-backdrop");
        while (modalBackdrops.length > 0) {
            modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
        }
    };

    // Handle Share Click
    const handleShare = (doctor) => {
        const doctorProfileUrl = `${window.location.origin}/details-doctors/${doctor.id}`;
        if (navigator.share) {
            navigator
                .share({
                    title: `Check out Dr. ${doctor.name}`,
                    text: `Learn more about Dr. ${doctor.name}, a specialist in ${doctor.speciality}.`,
                    url: doctorProfileUrl,
                })
                .catch((error) => console.error("Error sharing:", error));
        } else {
            alert("Sharing is not supported in this browser.");
        }
    };

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const response = await fetchSpecialityVideos(id);
                if (response && response.data) {
                    setVideos(response.data);
                }
            } catch (error) {
                console.error("Error fetching videos:", error);
            } finally {
                setLoadingVideos(false);
            }
        };

        fetchVideos();
    }, [id]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (!speciality) {
        return <p>Speciality not found.</p>;
    }

    return (
        <>
            {/* Banner Section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        <img src={SpecialBan} alt="" />
                        <div className="ban-con">
                            <h1>{speciality.name}</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Navigation Section */}
            <section className="special-detail-target-sec mrgntop70">
                <div className="cust-container">
                    <div className="special-detail-target-inner">
                        <ul>
                            <li>
                                <a href="#overviewid">Overview</a>
                            </li>
                            <li>
                                <a href="#diseasesid">DISEASE</a>
                            </li>
                            <li>
                                <a href="#treatmentid">TREATMENT</a>
                            </li>
                            <li>
                                <a href="#procedureid">PROCEDURE</a>
                            </li>
                            <li>
                                <a href="#technologyid">Technology</a>
                            </li>
                            <li>
                                <a href="#expert-cardiologistid">Doctors</a>
                            </li>
                            {/* <li>
                <a href="#expert-cardiologistid">Our Expert Cardiologist</a>
              </li> */}
                            <li>
                                <a href="#ourvideosid">Videos</a>
                            </li>
                            <li>
                                <a href="#ourblogs">Blogs</a>
                            </li>
                            <li>
                                <a href="#patientstoriesid">Patient Stories</a>
                            </li>
                            <li>
                                <a href="#faqid">FAQ</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Overview Section */}
            <section className="overview-sec mrgntop70" id="overviewid">
                <div className="cust-container">
                    <div className="finnest host-det">
                        <h4>Overview</h4>
                        <div className="ck-content" dangerouslySetInnerHTML={{
                            __html: speciality.overview || "No description available.",
                        }} />
                        {/* <p>{speciality.description || "No description available."}</p> */}
                        {/* </p> */}
                    </div>
                </div>
            </section>

            {/* Diseases Section */}
            <section className="overview-sec mrgntop70" id="diseasesid">
                <div className="cust-container">
                    <div className="finnest host-det">
                        <h4>Diseases</h4>
                        <div className="ck-content" dangerouslySetInnerHTML={{
                            __html: speciality.disease || "No Diseases details available.",
                        }} />
                        {/* <p>{speciality.description || "No description available."}</p> */}
                        {/* </p> */}
                    </div>
                </div>
            </section>

            {/* Treatment Section */}
            {speciality.treatment && (
                <section className="overview-sec mrgntop70" id="treatmentid">
                    <div className="cust-container">
                        <div className="finnest host-det">
                            <h4>Treatment</h4>
                            <div className="ck-content" dangerouslySetInnerHTML={{ __html: speciality.treatment }} />
                        </div>
                    </div>
                </section>
            )}

            {/* Procedure Section */}
            {speciality.procedure && (
                <section className="overview-sec mrgntop70" id="procedureid">
                    <div className="cust-container">
                        <div className="finnest host-det">
                            <h4>Procedure</h4>
                            <div className="ck-content" dangerouslySetInnerHTML={{ __html: speciality.procedure }} />
                        </div>
                    </div>
                </section>
            )}

            {/* Technology Section */}
            {speciality.technology && (
                <section className="overview-sec mrgntop70" id="technologyid">
                    <div className="cust-container">
                        <div className="finnest host-det">
                            <h4>Technology</h4>
                            <div className="ck-content" dangerouslySetInnerHTML={{ __html: speciality.technology }} />
                        </div>
                    </div>
                </section>
            )}

            {/* Our Expert Cardiologist Section */}
            {/* <section className="our-expert-cardiologist-sec mrgntop70 margnbot90" id="expert-cardiologistid">
                <div className="cust-container">
                    <div className="finnest host-det text-center margin-botom40">
                        <h4>Our Expert Cardiologist</h4>
                    </div>
                    <div className="row">
                        {doctors.length > 0 ? (
                            doctors.map((doctor) => (
                                <div key={doctor.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                                    <div className="oueextpert-cardiolo-item">
                                        <div className="cardiolo-item-img">
                                            <img
                                                src={
                                                    doctor.img_path
                                                        ? `${baseImage_path}/${doctor.img_path.replace(/^\./, "")}`
                                                        : `${baseImage_path}/images/default-doctor.png`
                                                }
                                                alt={doctor.name}
                                            />
                                        </div>
                                        <div className="cardiolo-itemdesc">
                                            <div className="drs-design">
                                                <span>{doctor.speciality_name}</span>
                                                <a href="#">View Profile</a>
                                            </div>
                                            <div className="drs-title">
                                                <h4>{doctor.name}</h4>
                                            </div>
                                            <p>{doctor.experience ? `Total Experience - ${doctor.experience} yrs` : "Experience not available"}</p>
                                            <div className="drs-bookapp-cta common-roundcta">
                                                <a href="#">Book Appointment</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No doctors available for this specialty.</p>
                        )}
                    </div>
                </div>
            </section> */}
            {/* <section className="section expert-doctors" id="expert-cardiologistid">
        <div className="finnest host-det text-center margin-botom40">
          <h4>Our Expert Cardiologist</h4>
        </div>
        <div className="cust-container">
          <div className="doctor-box">
            <div className="row">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                <div className="oueextpert-cardiolo-item">
                  <div className="cardiolo-item-img">
                    <img src={Doct1} alt="Dr. Alka Kumar" />
                  </div>
                  <div className="cardiolo-itemdesc">
                    <div className="drs-design">
                      <span>Gynecologist</span>
                      <NavLink to="/doctor" style={{ color: "#0ca854" }}>View Profile</NavLink>
                    </div>

                    <div className="drs-title">
                      <h4>Dr. Alka Kumar</h4>
                      <div className="drs-title-shareicn">
                        <img src={VectorIcon} alt="Share Icon"
                          style={{ cursor: "pointer" }} />
                      </div>
                    </div>
                    <p>Total Experience - 15yrs</p>
                    <div className="drs-bookapp-cta common-roundcta">
                      <NavLink to="/doctor" className="btn without-color btnhv">Book Appointment</NavLink>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                <div className="oueextpert-cardiolo-item">
                  <div className="cardiolo-item-img">
                    <img src={Doct2} alt="Dr. Alok Pandey" />
                  </div>
                  <div className="cardiolo-itemdesc">
                    <div className="drs-design">
                      <span>Orthopedist</span>
                      <NavLink to="/doctor" style={{ color: "#0ca854" }}>View Profile</NavLink>
                    </div>

                    <div className="drs-title">
                      <h4>Dr. Alok Pandey</h4>
                      <div className="drs-title-shareicn">
                        <img src={VectorIcon} alt="Share Icon"
                          style={{ cursor: "pointer" }} />
                      </div>
                    </div>
                    <p>Total Experience - 15yrs</p>
                    <div className="drs-bookapp-cta common-roundcta">
                      <NavLink to="/doctor" className="btn without-color btnhv">Book Appointment</NavLink>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                <div className="oueextpert-cardiolo-item">
                  <div className="cardiolo-item-img">
                    <img src={Doct3} alt="Dr. Aditi Phulpagar" />
                  </div>
                  <div className="cardiolo-itemdesc">
                    <div className="drs-design">
                      <span>Gynecologist</span>
                      <NavLink to="/doctor" style={{ color: "#0ca854" }}>View Profile</NavLink>
                    </div>

                    <div className="drs-title">
                      <h4>Dr. Aditi Phulpagar</h4>
                      <div className="drs-title-shareicn">
                        <img src={VectorIcon} alt="Share Icon"
                          style={{ cursor: "pointer" }} />
                      </div>
                    </div>
                    <p>Total Experience - 15yrs</p>
                    <div className="drs-bookapp-cta common-roundcta">
                      <NavLink to="/doctor" className="btn without-color btnhv">Book Appointment</NavLink>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                <div className="oueextpert-cardiolo-item">
                  <div className="cardiolo-item-img">
                    <img src={Doct4} alt="Dr. Pankaj Gupta" />
                  </div>
                  <div className="cardiolo-itemdesc">
                    <div className="drs-design">
                      <span>Orthopedist</span>
                      <NavLink to="/doctor" style={{ color: "#0ca854" }}>View Profile</NavLink>
                    </div>

                    <div className="drs-title">
                      <h4>Dr. Pankaj Gupta</h4>
                      <div className="drs-title-shareicn">
                        <img src={VectorIcon} alt="Share Icon"
                          style={{ cursor: "pointer" }} />
                      </div>
                    </div>
                    <p>Total Experience - 15yrs</p>
                    <div className="drs-bookapp-cta common-roundcta">
                      <NavLink to="/doctor" className="btn without-color btnhv">Book Appointment</NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

            {/* Videos Section */}
            {/* <section className="our-video-sec mrgntop70 margnbot90" id="ourvideosid">
        <div className="cust-container">
          <div className="finnest host-det text-center margin-botom40">
            <h4>Videos</h4>
          </div>
          <div className="video-slider-container">
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              slidesPerView={3}
              loop={true}
              navigation={{
                nextEl: ".video-swiper-next",
                prevEl: ".video-swiper-prev",
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: { slidesPerView: 1 },
                1024: { slidesPerView: 2 },
                1280: { slidesPerView: 3 },
              }}
            >
              {[...Array(6)].map((_, index) => (
                <SwiperSlide key={index}>
                  <div className="our-video-sec-item">
                    <div className="our-video-img">
                      <img src={videoImg} alt="" />
                    </div>
                    <div className="our-video-desc">
                      <h4>Name of the Video</h4>
                      <a href="javascript:;" onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}>
                        Watch now <img src={blkArrow} alt="Arrow" />
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="video-slider-nav">
              <span className="video-swiper-prev">
                <img src={leftArrow} alt="Previous" />
              </span>
              <span className="video-swiper-next">
                <img src={leftArrow} alt="Next" style={{ transform: "rotate(180deg)" }} />
              </span>
            </div>
          </div>
        </div>
      </section> */}
            {/* Videos Section */}
            {videos.length > 0 && (
                <section className="our-video-sec mrgntop70 margnbot90" id="ourvideosid">
                    <div className="cust-container">
                        <div className="finnest host-det text-center margin-botom40">
                            <h4>Videos</h4>
                        </div>
                        <div className="video-slider-container">
                            <Swiper
                                modules={[Navigation, Autoplay]}
                                spaceBetween={20}
                                slidesPerView={3}
                                loop={true}
                                navigation={{
                                    nextEl: ".video-swiper-next",
                                    prevEl: ".video-swiper-prev",
                                }}
                                autoplay={{
                                    delay: 4000,
                                    disableOnInteraction: false,
                                }}
                                breakpoints={{
                                    640: { slidesPerView: 1 },
                                    1024: { slidesPerView: 2 },
                                    1280: { slidesPerView: 3 },
                                }}
                            >
                                {videos.map((video) => (
                                    <SwiperSlide key={video.id}>
                                        <div className="our-video-sec-item">
                                            <div className="our-video-img">
                                                <img
                                                    src={video.thumbnail_img ? `${baseImage_path}${video.thumbnail_img}` : "default-image.jpg"}
                                                    alt={video.title}
                                                />
                                            </div>
                                            <div className="our-video-desc">
                                                <h4>{video.title}</h4>
                                                <a href={video.video_url} target="_blank" rel="noopener noreferrer">
                                                    Watch now <img src={blkArrow} alt="Arrow" />
                                                </a>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>

                            {/* Navigation Arrows */}
                            <div className="video-slider-nav">
                                <span className="video-swiper-prev">
                                    <img src={leftArrow} alt="Previous" />
                                </span>
                                <span className="video-swiper-next">
                                    <img src={leftArrow} alt="Next" style={{ transform: "rotate(180deg)" }} />
                                </span>
                            </div>
                        </div>
                    </div>
                </section>
            )}


            {/* Our Blogs Section */}
            <section
                className="our-blogs-sec mrgntop70 margnbot90"
                id="ourblogs"
            >
                <div className="cust-container">
                    <div className="finnest host-det text-center margin-botom40">
                        <h4>Our Blogs</h4>
                    </div>
                    <div className="row">
                        {blogs.slice(0, 3).map((blog) => (
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4" >
                                <div className="our-video-sec-item">
                                    <div className="our-video-img">
                                        <img
                                            src={`${baseImage_path}/${blog.featured_img || "default-blog.jpg"}`}
                                            alt={blog.title}
                                        />
                                        <div className="our-vdo-categ">
                                            <span>{blog.category || "Uncategorized"}</span>
                                        </div>
                                        <div className="our-video-desc our-vdo-desc-cta-green">
                                            <span>{new Date(blog.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</span>
                                            <p>{blog.title}</p>
                                            <a href={`/blogs-details/${blog.id}`}>Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="patient-story-sec mrgntop70 margnbot90" id="patientstoriesid">
                <div className="cust-container">
                    <div className="finnest host-det text-center margin-botom40">
                        <h4>Patient Stories</h4>
                    </div>

                    <div className="patient-items">
                        <div className="patei-item patient-col1">
                            <div className="patien-img">
                                <img src={grid1Img} alt="" />
                                <div className="patien-vdoplaybtn">
                                    <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                        data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                </div>
                                <div className="patien-desc">
                                    <h4>Mauritian Patient Treated For Esophageal Cancer</h4>
                                    <span>Mr Fazl Hosany</span>
                                </div>
                            </div>

                        </div>
                        <div className="patei-item patient-col2">
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid2Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Neurosurgical Treatment</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid3Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Bone Marrow Transplant</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="patei-item patient-col3">
                            <div className="patien-img">
                                <img src={grid4Img} alt="" />
                                <div className="patien-vdoplaybtn">
                                    <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                        data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                </div>
                                <div className="patien-desc">
                                    <h4>Pre-term Babies</h4>
                                    <span>Ms Sakshi</span>
                                </div>
                            </div>

                        </div>
                        <div className="patei-item patient-col2">
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid2Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Neurosurgical Treatment</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>
                            <div className="patient-col-inner">
                                <div className="patien-img">
                                    <img src={grid3Img} alt="" />
                                    <div className="patien-vdoplaybtn">
                                        <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                            data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                    </div>
                                    <div className="patien-desc">
                                        <h4>Bone Marrow Transplant</h4>
                                        <span>Mr Fazl Hosany</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="patei-item patient-col1">
                            <div className="patien-img">
                                <img src={grid1Img} alt="" />
                                <div className="patien-vdoplaybtn">
                                    <button onClick={() => handleOpenVideo("https://www.youtube.com/embed/3ql1yXsvavU")}
                                        data-toggle="modal" data-target="#patientvdo"><img src={videoPlaybtn} alt="" /></button>
                                </div>
                                <div className="patien-desc">
                                    <h4>Mauritian Patient Treated For Esophageal Cancer</h4>
                                    <span>Mr Fazl Hosany</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-sec mrgntop70 margnbot90" id="faqid">
                <div className="cust-container">
                    <div className="finnest host-det text-center margin-botom40">
                        <h4>FAQ</h4>
                    </div>
                    <div className="faqsec-inner">
                        <div className="accordion" id="special-detail-faqs">
                            {faq.length > 0 ? (
                                faq.map((item, index) => (
                                    <div className="card" key={item.id}>
                                        <div className="card-header" id={`heading${item.id}`}>
                                            <button
                                                className="collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target={`#collapse${item.id}`}
                                                aria-expanded="false"
                                                aria-controls={`collapse${item.id}`}
                                            >
                                                {item.question}
                                            </button>
                                        </div>
                                        <div
                                            id={`collapse${item.id}`}
                                            className="collapse"
                                            aria-labelledby={`heading${item.id}`}
                                            data-parent="#special-detail-faqs"
                                        >
                                            <div className="card-body">
                                                {/* <p>{item.answer}</p> */}
                                                <p dangerouslySetInnerHTML={{ __html: item.answer }} />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No FAQs available for this specialty.</p>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal for patient video */}
            {showVideoModal && (
                <div
                    className="modal fade custmodal-width show"
                    style={{ display: "block" }}
                    id="patientvdo"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modalclosebtn">
                                <button
                                    type="button"
                                    className="close"
                                    onClick={handleCloseVideo}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {videoUrl && (
                                    <iframe
                                        src={videoUrl}
                                        title="Video Player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    ></iframe>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default InternalMedicine;
